<div class="extras px-2 pt-2">
  @if (isVideo) {
  <fa-icon class="feed-article-icon mr-2" [icon]="['fas', 'video']"></fa-icon>
  } @if (isDirectShow) {
  <fa-icon class="feed-article-icon mr-2" [icon]="['fas', 'tag']"></fa-icon>
  }

  <span #badgesRef>
    <ng-content select="[badges]"></ng-content>
  </span>
  <div class="d-flex align-items-center ml-auto">
    @if (showPins) { @if (isPinned) {
    <button
      class="btn rounded-circle feed-action-button"
      [class.visible]="visiblePins$ | async"
      [atxTooltip]="isLookbook ? pinLookbookText : pinText"
      data-e2e="unpin"
      tooltipPlacement="left"
      (click)="togglePinState.emit(true)"
    >
      <fa-icon [icon]="faThinPin" size="xs"></fa-icon>
    </button>
    } @else {
    <button
      class="btn rounded-circle feed-action-button"
      [class.visible]="visiblePins$ | async"
      data-e2e="pin"
      [atxTooltip]="isLookbook ? unpinLookbookText : unpinText"
      tooltipPlacement="left"
      (click)="togglePinState.emit(false)"
    >
      <fa-icon [icon]="faThinUnpin" size="xs"></fa-icon>
    </button>
    } }
    <ng-container
      *epcFeatureFlag="
        enableNewsfeedDelete;
        namespace: newsfeedNamespace;
        equality: true;
        defaultValue: false
      "
    >
      @if (showBin) {
      <button
        class="btn rounded-circle feed-action-button ml-2"
        [class.visible]="visiblePins$ | async"
        [atxTooltip]="isLookbook ? deleteLookbookText : deleteText"
        data-e2e="delete-newsfeed-item"
        tooltipPlacement="left"
        (click)="delete.emit(); $event.stopImmediatePropagation()"
      >
        <fa-icon [icon]="['fas', 'trash']" size="xs"></fa-icon>
      </button>
      }
    </ng-container>
  </div>
</div>
@if ( isVideo || isDirectShow || (badgesRef.children.length > 0 &&
badgesRef.innerHTML.trim()) ) {
<div
  class="icon-visibility-layer"
  [class.icon-visibility-layer--lookbook]="isLookbook"
></div>
} @if (isShowIndicator) {
<epc-hot-list-indicator
  [listId]="referenceId"
  [listIds]="referenceIds"
></epc-hot-list-indicator>
} @if ( (!isLookbook && hasCommercialList) || (isLookbook && isShowIndicator &&
hasCommercialList) ) {
<epc-commercial-list-ribbon
  class="list-type-badge-wrapper"
  [class.list-type-badge-wrapper--lookbook]="isLookbook"
></epc-commercial-list-ribbon>
} @if (hasPowerList) {
<div class="list-type-badge-wrapper">
  <fa-icon
    class="text-yellow d-inline-block"
    [icon]="['fas', 'medal']"
  ></fa-icon>
</div>
} @if (!isLookbook) {
<a class="stretched-link" (click)="clickListener($event)"></a>
}
